import React, { useState } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { eventPOST } from '../EventApi';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
const EventForm = ({ onSuccess }) => {

  
const today = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Asia/Manila',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
}).format(new Date()).replace(/\//g, '-');
  const nowPH = new Date();

const todayDate = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Asia/Manila',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
}).format(nowPH).replace(/\//g, '-');

const currentTime = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Asia/Manila',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
}).format(nowPH);


  const [formData, setFormData] = useState({
    event_name: '',
    event_date: today,
    start_time: '',
    end_time: '',
    description: '',
    max_participants: '',
    address: '',
    venue: '',
    permission: 'none',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

 const handleSubmit = async (e) => {
  e.preventDefault();

  // REPLACE EVERYTHING BELOW YOUR CURRENT VALIDATION WITH THIS:

  const now = new Date();
  const eventDate = new Date(formData.event_date);

  const [startH, startM] = formData.start_time.split(":").map(Number);
  const [endH, endM] = formData.end_time.split(":").map(Number);

  const startDateTime = new Date(eventDate);
  startDateTime.setHours(startH, startM, 0, 0);

  const endDateTime = new Date(eventDate);
  endDateTime.setHours(endH, endM, 0, 0);

  if (Number(formData.max_participants) <= 0) {
    alert("Max participants must be greater than zero");
    return;
  }

  if (!formData.start_time || !formData.end_time) {
    alert("Start and end time are required");
    return;
  }

  if (startDateTime < now) {
    alert("Start time cannot be in the past");
    return;
  }

  if (endDateTime <= startDateTime) {
    alert("End time must be later than start time");
    return;
  }

  try {
    const { start_time, end_time, ...rest } = formData;

    const payload = {
      ...rest,
      time_range: `${start_time}-${end_time}`,
      max_participants: Number(formData.max_participants),
    };

    await eventPOST(payload);

    setFormData({
      event_name: '',
      event_date: today,
      start_time: '',
      end_time: '',
      description: '',
      max_participants: '',
      address: '',
      venue: '',
      permission: 'none',
    });

    if (onSuccess) onSuccess();

  } catch (err) {
    alert('❌ Failed to create event: ' + (err.message || 'Unknown error'));
  }
};

  return (

    <Form
      onSubmit={handleSubmit}
    >
      {/* Event Name & Date */}

      <Row className="mb-3 g-3">
        {/* Event Name (wider) */}
        <Col xs={12} md={7} className="d-flex flex-column">
          <Form.Label className="form-label-sm mb-1">Event Name</Form.Label>
          <Form.Control
            size="sm"
            type="text"
            name="event_name"
            value={formData.event_name}
            onChange={handleChange}
            style={{ width: '100%' }}
            required
          />
        </Col>

        {/* Event Date (smaller) */}
        <Col xs={12} md={5} className="d-flex flex-column">
          <Form.Label className="form-label-sm mb-1">Event Date</Form.Label>
          <DatePicker
            selected={formData.event_date}
            onChange={(date) =>
              setFormData((prev) => ({ ...prev, event_date: date }))
            }
            minDate={new Date()}
            dateFormat="yyyy-MM-dd"
            required
            customInput={
              <input
                type="text"
                className="form-control form-control-sm"
                style={{ width: '100%' }}
              />
            }
          />
        </Col>
      </Row>




      {/* Time Range */}
      <Row className="mb-3">
         <Col xs="auto">
    <Form.Label className="form-label-sm mb-0 me-2">Start Time</Form.Label>
    <Form.Control
      size="sm"
      type="time"
      name="start_time"
      value={formData.start_time}
      onChange={handleChange}
      style={{ width: '200px' }}
      required
      onClick={(e) => e.target.showPicker?.()}
    />
  </Col>

        <Col xs="auto">
          <Form.Label className="form-label-sm mb-0 me-2">End Time</Form.Label>
          <Form.Control
            size="sm"
            type="time"
            name="end_time"
            value={formData.end_time}
            onChange={handleChange}
            style={{ width: '200px' }}
            required
            onClick={(e) => e.target.showPicker?.()} // opens time picker in supported browsers
          />
        </Col>

      </Row>

      {/* Description */}
      <Form.Group className="mb-3">
        <Form.Label className="form-label-sm mb-1">Description</Form.Label>
        <Form.Control
          as="textarea"
          size="sm"
          name="description"
          value={formData.description}
          onChange={handleChange}
          style={{ height: '120px' }}
        />
      </Form.Group>



      {/* Max Participants & Permission in one row (inline labels) */}
      <Row className="mb-3">
        <Col md={6} className="d-flex align-items-center">
          <label className="form-label-sm me-2 mb-0">
            Maximum Participants
          </label>
          <Form.Control
            size="sm"
            type="number"
            name="max_participants"
            value={formData.max_participants}
            onChange={handleChange}
            style={{ width: '100px' }} // input width stays fixed
          />
        </Col>

        <Col
          md={6}
          className="d-flex align-items-center justify-content-end"
        >
          <label
            className="form-label-sm me-2 mb-0"
            style={{ width: '80px', flexShrink: 0 }}
          >
            Permission
          </label>
          <Form.Select
            size="sm"
            name="permission"
            value={formData.permission}
            onChange={handleChange}
            style={{ width: '200px' }}
          >
            <option value="none">None</option>
            <option value="need_permission">Need permission</option>
          </Form.Select>
        </Col>

      </Row>

      {/* Venue row */}
      <Row className="mb-3">
        <Col className="d-flex align-items-center" style={{ maxWidth: '600px' }}>
          <label className="form-label-sm me-2 mb-0" style={{ width: '80px' }}>
            Venue
          </label>
          <Form.Control
            size="sm"
            type="text"
            name="venue"
            value={formData.venue}
            onChange={handleChange}
            style={{ width: '300px' }}
          />
        </Col>
      </Row>

      {/* Address + Create Button inline */}
      <Row className="mb-3 align-items-center">
        <Col className="d-flex align-items-center" style={{ maxWidth: '600px' }}>
          <label className="form-label-sm me-2 mb-0" style={{ width: '80px' }}>
            Address
          </label>
          <Form.Control
            size="sm"
            type="text"
            name="address"
            value={formData.address}
            onChange={handleChange}
            style={{ width: '300px' }}
          />
        </Col>

        <Col xs="auto" className="text-end mt-2 mt-md-0">
          <Button
            type="submit"
            style={{
              backgroundColor: '#f5d467ff', // button color
              border: 'none',               // remove border
              borderRadius: '10px',         // rounded corners
              padding: '0.75rem 1.5rem',    // keep padding
            }}
          >
            Create Event
          </Button>
        </Col>




      </Row>









    </Form>








  );
};

export default EventForm;
